<template>
    <div :class="['textBox',{check: isCheck,disabled:disabled}]">
        <span class="placeholder" v-show="!text">{{placeholder}}</span>
        <span v-show="text">{{text}}</span>
        <img v-if="iconShow" src="@/assets/img/arkHome/rightIcon.png" alt="">
    </div>
</template>
<script>
export default {
  data() {
    return {

    };
  },
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    iconShow: {
      type: Boolean,
      default: true,
    },
    isCheck: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss" scoped>
.textBox {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 605px;
    height: 91px;
    margin: 22px auto 0;
    padding: 0 36px;
    color: #333;
    font-size: 25px;
    border: 2px solid #E8E8E8;
    border-radius: 45px;
    .placeholder {
        color: #999;
    }
    img {
        width: 43px;
        height: 43px;
    }
}
.check {
    color:#fff;
    background: #FF7F41;
    border: none;
}
.disabled {
    background: #9fa8b533;
}
</style>
